/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { formatDate } from "utils/formatters";
import { recortarTexto } from "utils/formatters";
import { makeNiceText } from "utils/formatters";

const getRows = (data, handleOpenMenu) => {
  const estadoStock = {
    "Sin registro": { icon: "block", color: "secondary" },
    Pendiente: { icon: "hourglass_empty", color: "uproYellow" },
    Verificado: { icon: "check_circle_outline", color: "uproGreen" },
  };

  const coloresEstado = {
    Anulado: "error",
  };

  const rows = [];
  if (data) {
    data.forEach((item, index) => {
      rows.push({
        hasBorder: index !== data.length - 1,
        id: (
          <SoftBox
            display="flex"
            alignItems="center"
            gap={0.5}
            ml={3}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title={item?.fechaAnulacion ? "Anulado" : "Pedido"} placement="top">
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color: item?.fechaAnulacion ? "red" : getUproColor("uproGreen"),
                }}
                fontSize="lg"
              >
                {item?.fechaAnulacion ? "close" : "receipt"}
              </Icon>
            </Tooltip>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        fecha: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {formatDate(item?.createdAt, "dd/MM/yyyy") || "-"}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox
            sx={{
              cursor: "pointer",
              maxWidth: "600px",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.nombre
                ? makeNiceText(recortarTexto(item?.nombre, 65), "nombre")
                : "Pedido nº " + item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title={item.motivoAnulacion ?? makeNiceText(item.estado ?? "")}>
              {item.estadoBase && !Object.keys(coloresEstado).includes(item.estado) ? (
                <SoftBox display="flex" justifyContent="center">
                  <SoftBox
                    display="flex"
                    alignItems="center"
                    gap={0.5}
                    borderRadius="md"
                    bgColor={
                      item.estadoBase.area === "Solicitante"
                        ? getUproColor("uproYellow")
                        : getUproColor("uproGreen")
                    }
                    py={0.4}
                    px={0.5}
                  >
                    <SoftTypography fontSize="0.6rem" variant="caption" color="white">
                      {item.estadoBase.area?.toUpperCase()}
                    </SoftTypography>
                    <SoftBox display="flex" borderRadius="sm" bgColor="white" px={1} py={0.1}>
                      <SoftTypography
                        fontSize="0.6rem"
                        variant="caption"
                        color="secondary"
                        fontWeight="medium"
                      >
                        {item.estadoBase.nombre?.split(" ").slice(0, 3).join(" ")}
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              ) : (
                <SoftBadge
                  badgeContent={item.estado?.split(" ").slice(0, 5).join(" ")}
                  color={coloresEstado[item.estado] ?? "dark"}
                />
              )}
            </Tooltip>
          </SoftBox>
        ),
        // almacen: (
        //   <SoftBox
        //     display="flex"
        //     justifyContent="center"
        //     alignItems="center"
        //     sx={{
        //       cursor: "pointer",
        //     }}
        //     onClick={(e) => handleOpenMenu(e, item)}
        //   >
        //     <Tooltip title={item.stockEstado || "Sin registro"}>
        //       <Icon
        //         fontSize="small"
        //         sx={{
        //           color: getUproColor(estadoStock[item.stockEstado]?.color),
        //         }}
        //       >
        //         {estadoStock[item.stockEstado]?.icon || "info"}
        //       </Icon>
        //     </Tooltip>
        //   </SoftBox>
        // ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "id", desc: "ID", width: "1%", align: "center" },
  { name: "fecha", desc: "fecha", align: "center" },
  { name: "nombre", desc: "Nombre", align: "left" },
  { name: "estado", desc: "estado", align: "center", noOrder: true },
  // { name: "almacen", desc: "Almacén", align: "center", noOrder: true, width: "1%" },
];

export default { columns, getRows };
